import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import Preloader from "../components/preloader/Preloader";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import StudentPermissionHome from '../components/studentPermission/StudentPermissionHome'
import { color } from "highcharts";

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
    }
  }
`;

const FETCH_STUDENTS = gql`
  query($institution_id: Int!) {
    getStudents(institution_id: $institution_id) {
      id
      student_name
      contact_no
      branch_id
      class_id
      section_id
      package_id
      category_id
      exam_id
    }
  }
`;

const FETCH_PARENT_PERMISSION = gql`
query($institute_id: Int!) {
  getParentsPermissionDetails(institute_id: $institute_id) {
    class_id
    exam_id
    branch_id
    section_id
    class_name
    exam_name
    branch_name
    section_name
    permission_id
    student_name
    roll_no
    student_mobile
    request_date
    from_datetime
    to_datetime
    receiver_name
    receiver_mobile
    request_message
    receiver_image_path
    parent_name
    parent_mobile
    permission_status
    comments
    approved_time
    approved_by
    outtime
    outtime_image_path
    outtime_inserted_by
    intime
    intime_image_path
    intime_inserted_by
    permission_request_type_id
    request_title
  }
}
`;

const FETCH_PERMISSION_REQUEST_TYPES = gql`
query($id: Int) {
  getPermissionRequestTypes(id: $id) {
    id
    permission_request_type
  }
}
`;


export class StudentPermission extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggled: Cookies.get("toggle")
    }
  }
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");

    const globals = this.props.globals
    console.log("ggg", globals);
    const loading1 = globals.loading;
    const error1 = globals.error;

    const getStudents = this.props.getStudents;
    const loading2 = getStudents.loading;
    const error2 = getStudents.error;

    const getParentsPermissionDetails = this.props.getParentsPermissionDetails;
    const loading3 = getParentsPermissionDetails.loading;
    const error3 = getParentsPermissionDetails.error;

    const getPermissionRequestTypes = this.props.getPermissionRequestTypes;
    const loading4 = getPermissionRequestTypes.loading;
    const error4 = getPermissionRequestTypes.error;

    // if (loading1 || loading2 ||  loading3 || loading4) return null;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }
    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }
    if (error3 !== undefined) {
      alert("Server Error. " + error3.message);
      return null;
    }
    if (error4 !== undefined) {
      alert("Server Error. " + error4.message);
      return null;
    }
    // console.log("hhh",getPermissionRequestTypes)

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
            {
              loading1 || loading2 || loading3 || loading4 ?
                (
                  <Container><Row className="my-3">
                    <Col>
                      <div class="spinner-border text-primary text-center loading-img-center"></div>
                    </Col>
                  </Row>
                  </Container>
                )
                :
                (
                  <>
                    {
                      (() => {
                        let globalsData = globals.globals;

                        if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                          let globalBranches = [];

                          globalsData.globalBranches.map((item) => {
                            if (Cookies.get("branch_id") == item.id) {
                              globalBranches.push(item)
                            }
                          });

                          globalsData.globalBranches = globalBranches

                        }
                        console.log("globalsData", globalsData);

                        return (
                          <>

                            <StudentPermissionHome
                              globals={globalsData}
                              getParentsPermissionDetails={getParentsPermissionDetails.getParentsPermissionDetails}
                              getPermissionRequestTypes={getPermissionRequestTypes.getPermissionRequestTypes}
                            />
                          </>
                        );
                      })()
                    }
                  </>
                )}
          </div>
          <Footer />
        </div>
      </div>
    )
  }
}

export default withRouter(
  compose(

    graphql(FETCH_GLOBALS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))

          }
        }), name: "globals"
      }),
    graphql(FETCH_STUDENTS, {
      options: (props) => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
        },
        fetchPolicy: "cache-and-network",
      }),
      name: "getStudents",
    }),
    graphql(FETCH_PARENT_PERMISSION, {
      options: (props) => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
        },
        fetchPolicy: "cache-and-network",
      }),
      name: "getParentsPermissionDetails",
    }),
    graphql(FETCH_PERMISSION_REQUEST_TYPES, {
      options: (props) => ({
        variables: {
          id: parseInt(Cookies.get("institutionid")),
        },
        fetchPolicy: "cache-and-network",
      }),
      name: "getPermissionRequestTypes",
    }),
  )
    (StudentPermission));